// import DatePicker from "react-datepicker";
import React, { useState, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import { DatePicker } from "rsuite";
import { useTranslation } from "react-i18next";
import Calender from "../assets/images/svgs/calendar.svg";

// Custom Input (allows icon click and input typing)
const CustomInput = forwardRef(
  ({ value, placeholder, onClick, onChange }, ref) => (
    <div className="date-picker-wrapper d-flex" ref={ref}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        onClick={onClick}
        className="date-input form-control form-control-solid"
        placeholder={placeholder}
      />
      <img
        src={Calender}
        alt=""
        className="svg-icon"
        style={{ marginLeft: "-40px", cursor: "pointer" }}
        onClick={onClick}
      />
    </div>
  )
);

const DateInput = ({ name, value, title, handleChange, error, disabled, page }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if(value) {
      setSelectedDate(value)
    }
  }, [value])

  useEffect(() => {
    if (selectedDate) {
      handleChange({ name, value: selectedDate });
    }
  }, [selectedDate]);

  // 🔍 Parse and validate manually typed date
  const handleRawChange = (e) => {
    console.log(e);
    setSelectedDate(e);
    // const typed = e.target.value.trim();
    // const [dd, mm, yyyy] = typed.split("-");

    // if (
    //   dd &&
    //   mm &&
    //   yyyy &&
    //   dd.length === 2 &&
    //   mm.length === 2 &&
    //   yyyy.length === 4
    // ) {
    //   const parsed = new Date(`${yyyy}-${mm}-${dd}`);
    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);

    //   if (!isNaN(parsed) && parsed <= today) {
    //     setSelectedDate(parsed);
    //   }
    // }
  };

  return (
    <div className={`   text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      {/* <DatePicker
        selected={selectedDate}
        onChange={(date) => {
          if (date && date <= new Date()) {
            setSelectedDate(date);
          }
        }}
        // onChangeRaw={handleRawChange}
        placeholderText="dd-mm-yyyy"
        dateFormat="dd-MM-yyyy"
        
        maxDate={new Date()}
        disabled={disabled}
        customInput={
          <CustomInput
            placeholder={t("Common.chooseDate")}
            onChange={handleRawChange}
          />
        }
      />
       <div style={page ? { height: "20px" } : {}}>
        <span className="fs-10 text-danger">{error}</span>
      </div> */}

      <DatePicker
        className=""
        value={selectedDate}
        onChange={handleRawChange}
      />

      <div style={page ? { height: "20px" } : {}} className="mb-2">
        <span className="fs-10 text-danger">{error}</span>
      </div>
    </div>
  );
};

DateInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  page: PropTypes.string,
};

export default DateInput;
